import gql from "graphql-tag";

export const hotsearchFragment = gql`
  fragment HotsearchFragment on Hotworld {
    id
    hotWord
    sortOrder
  }
`;
